import * as yup from "yup";

export const validationSchema = yup.object().shape({
  startDate: yup.string().required("Bu alan zorunludur."),
  endDate: yup.string().required("Bu alan zorunludur."),
});
